import moment from 'moment'
import { DateTime } from 'luxon'
import validator from 'validator'
import {
  packageCategories,
  urlCategories,
  urlCategoriesWithAnd,
  dynamicContractInput,
} from 'variables/general'

export const isValidEmail = (photographerEmail, clientEmail) => {
  return clientEmail !== photographerEmail && clientEmail !== 'contact@bookfocal.com'
}

export const verifyEmail = (value) => {
  const emailRex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailRex.test(value)
}

export const verifyLength = (value, length) => {
  return value.length >= length
}

export const verifyPhone = (value) => {
  const phoneRegex = /^\(?([+]?[0-9]{10,15})$/
  return phoneRegex.test(value)
}

export const shuffleArray = (value) => {
  if (value.length < 2) {
    return value
  }

  for (let i = value.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[value[i], value[j]] = [value[j], value[i]]
  }
  return value
}

export const getPriorityPackageCategoriesKeys = (cats = Object.keys(packageCategories)) => {
  return cats.sort((a, b) => {
    return packageCategories[a]?.priority - packageCategories[b]?.priority
  })
}

export function evenRound(num, decimalPlaces) {
  const d = decimalPlaces || 0
  const m = Math.pow(10, d)
  const n = +(d ? num * m : num).toFixed(8) // Avoid rounding errors
  const i = Math.floor(n),
    f = n - i
  const e = 1e-8 // Allow for rounding errors in f
  const r = f > 0.5 - e && f < 0.5 + e ? (i % 2 === 0 ? i : i + 1) : Math.round(n)
  return d ? r / m : r
}

export function getCategoryId(categoryName) {
  if (!categoryName) {
    return 2
  }
  const category = Object.keys(urlCategories).find((key) => urlCategories[key].name === categoryName)
  return category
}

export function getCategoryIdForPorfolio(categoryName) {
  const lowerCatName = categoryName.toLowerCase()

  if (!lowerCatName) {
    return 2
  }
  const category = Object.keys(urlCategoriesWithAnd).find(
    (key) => urlCategoriesWithAnd[key].name === lowerCatName,
  )
  return category
}

// USE THIS FOR PUBLIC PORTFOLIO BECAUSE ITS LINKED TO PHOTOGRAPHER WEBSITES
export function getCategoryIdPrivate(categoryName) {
  if (!categoryName) {
    return 2
  }
  let name = categoryName.replace(/-/g, ' ')
  return Object.keys(packageCategories).find(
    (key) => packageCategories[key].name.toLowerCase() === name.toLowerCase(),
  )
}

// USE THIS FOR PUBLIC PORTFOLIO BECAUSE ITS LINKED TO PHOTOGRAPHER WEBSITES
export function getCategoryName(categoryId) {
  if (!categoryId) {
    return ''
  }
  return packageCategories[String(categoryId)].name.replace(/ /g, '-').toLowerCase()
}

// USE THIS FOR MARKETPLACE PORTFOLIO
export function getMarketCategoryName(categoryId) {
  if (!categoryId) {
    return ''
  }
  return urlCategories[String(categoryId)].name
}

export function excludeZeroDecimal(flt) {
  return flt > ~~flt ? flt : ~~flt
}

export const openInNewTab = (url) => {
  const win = window.open(url, '_blank')
  if (win != null) {
    win.focus()
  }
}

export const durationFormat = function (t, minuteInterval) {
  if (minuteInterval) {
    t = `${Math.round((t / 60) * 100) / 100}`
    const hours = t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) : t
    const hourFraction = t.indexOf('.') >= 0 && 0 + t.substr(t.indexOf('.'))
    const minutes = hourFraction >= 0 && Math.round(hourFraction * 60)

    return hours > 0 && minutes
      ? `${hours} Hour & ${minutes} Minute`
      : hours > 0
      ? `${hours} Hour`
      : `${minutes} Minute`
  } else {
    t = `${t}`
    const hours = t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) : t
    const hourFraction = t.indexOf('.') >= 0 && 0 + t.substr(t.indexOf('.'))
    const minutes = hourFraction >= 0 && Math.round(hourFraction * 60)

    return hours > 0 && minutes
      ? `${hours} Hour & ${minutes} Minute`
      : hours > 0
      ? `${hours} Hour`
      : `${minutes} Minute`
  }
}

export const SortAndFilter = (dataTable, sortedColumn, sortedDirection, filteredColumn, filterText) => {
  if (!dataTable.length) return

  let dataTable1 = dataTable

  let nonNullTable = dataTable.filter((item) => item && item.UnformattedDateTime !== null)
  let nullContainingTable = dataTable.filter((item) => item && item.UnformattedDateTime === null)

  let nonNullNameTable = dataTable.filter((item) => item.customerName !== null)
  let nullContainingNameTable = dataTable.filter((item) => item.customerName === null)

  let isNum = sortedColumn ? /^[0-9]*\.?[0-9]*$/.test(dataTable[0][sortedColumn]) : null

  const aSort = (a, b) => a[sortedColumn] && a[sortedColumn].localeCompare(b[sortedColumn])
  const bSort = (a, b) => b[sortedColumn] && b[sortedColumn].localeCompare(a[sortedColumn])

  if (sortedColumn && sortedDirection && isNum) {
    dataTable1 = !dataTable
      ? []
      : sortedDirection === 'ascending'
      ? dataTable.sort((a, b) => (parseInt(a[sortedColumn], 10) > parseInt(b[sortedColumn], 10) ? 1 : -1))
      : dataTable.sort((a, b) => (parseInt(a[sortedColumn], 10) < parseInt(b[sortedColumn], 10) ? 1 : -1))
  } else if (sortedColumn === 'UnformattedDateTime' && sortedDirection && !isNum) {
    dataTable1 = !nonNullTable
      ? []
      : sortedDirection === 'ascending'
      ? nonNullTable.sort(aSort)
      : nonNullTable.sort(bSort)

    dataTable1 = dataTable1.concat(nullContainingTable)
  } else if (sortedColumn === 'customerName' && sortedDirection && !isNum) {
    dataTable1 = !nonNullNameTable
      ? []
      : sortedDirection === 'ascending'
      ? nonNullNameTable.sort(aSort)
      : nonNullNameTable.sort(bSort)

    dataTable1 = dataTable1.concat(nullContainingNameTable)
  } else if (sortedColumn && sortedDirection && !isNum) {
    dataTable1 = !dataTable
      ? []
      : sortedDirection === 'ascending'
      ? dataTable.sort(aSort)
      : dataTable.sort(bSort)
  }

  if (filteredColumn && filterText) {
    dataTable1 = dataTable1.filter(
      (item) => item[filteredColumn] && item[filteredColumn].toLowerCase().includes(filterText.toLowerCase()),
    )
  }

  return dataTable1
}

export const filterBookingRequestsText = (bookingRequests, text, latest) => {
  let result
  const newArray = [...bookingRequests].reverse()

  if (!latest) {
    result = newArray
  } else {
    result = bookingRequests
  }

  if (!!text) {
    result = result.filter(
      (el) =>
        el['customer']['email'].toLowerCase().includes(text.toLowerCase()) ||
        el['customer']['name'].toLowerCase().includes(text.toLowerCase()) ||
        el['package']['title'].toLowerCase().includes(text.toLowerCase()),
    )
  }

  return result
}

export const filterGalleryText = (galleries, text, latest) => {
  let result
  const newArray = [...galleries].reverse()

  if (!latest) {
    result = newArray
  } else {
    result = galleries
  }

  if (!!text) {
    result = result.filter(
      (el) =>
        el['customer']['email'].toLowerCase().includes(text.toLowerCase()) ||
        el['customer']['name'].toLowerCase().includes(text.toLowerCase()) ||
        el['package']['title'].toLowerCase().includes(text.toLowerCase()),
    )
  }

  return result
}

export const validateSocialUrl = (socials) => {
  for (const el of socials) {
    if (!validator.isURL(el.url)) {
      return false
    }
  }
  return true
}

export const validateUrl = (url) => {
  if (!validator.isURL(url)) {
    return false
  } else {
    return true
  }
}

export const shuffle = (array) => {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }
  return array
}

export const validateNumber = (num) => {
  if (num === '') {
    return true
  }
  if (parseInt(num) < 0) {
    return false
  } else {
    if (num.match(/^[0-9]+$/) === null) {
      return false
    } else {
      return true
    }
  }
}

// For length of shoot validation
export const validateFloatNumber = (num) => {
  if (num === '') {
    return true
  } else if (num === '0') {
    return true
  } else {
    const Num = parseFloat(num)
    return !isNaN(Num) && Number(Num) > 0
  }
}

export const returnKeyFromCategory = (packageCategories, activeCategory) => {
  let result
  for (const el in packageCategories) {
    if (packageCategories[el].name === activeCategory) {
      result = el
    }
  }
  return result
}

export const convertLocStr = (locStr) => {
  const arr = locStr.split('-').map((el) => {
    if (el === 'usa') {
      return 'USA'
    } else {
      const ss = el.split('')
      return ss[0].toUpperCase() + el.slice(1)
    }
  })
  return arr.join(', ')
}

export const formatBio = (str) => {
  let result
  let str1

  const replace_All = (search, replacement, text) => {
    return text.replace(new RegExp(search, 'g'), replacement)
  }

  if (str && str !== '<p><br></p>') {
    str1 = replace_All('<p><br></p>', '', str)
  }
  if (str1 && !str1.startsWith('<p>')) {
    result = '<p>' + str1 + '</p>'
    return result
  } else {
    return str1
  }
}

export const freeTimeSlots = (busy, dayStart, dayEnd, packageLength, buffer, timezone, isToday) => {
  let freeTime

  // For a day has schedule or not
  if (busy.length !== 0) {
    const busyTime = busy.map((el) => {
      const start = DateTime.fromISO(el['start']).setZone(timezone)
      const end = DateTime.fromISO(el['end']).setZone(timezone)

      // Handle Case: Whole day busy event
      if (end.day - start.day === 1 && end.hour === 0 && end.minute === 0) {
        return {
          start: { hour: start.hour, minute: start.minute },
          end: { hour: 24, minute: end.minute },
        }
      } else {
        return {
          start: { hour: start.hour, minute: start.minute },
          end: { hour: end.hour, minute: end.minute },
        }
      }
    })

    freeTime = busyTime.map((el, i) => {
      // Add first time slot
      if (i === 0) {
        return {
          start: dayStart,
          end: el.start,
        }
      } else {
        return {
          start: {
            hour: busyTime[i - 1].end.hour + buffer.hour,
            minute: busyTime[i - 1].end.minute + buffer.minute,
          },
          end: el.start,
        }
      }
    })

    // Add last time slot
    freeTime.push({
      start: {
        hour: busyTime[busyTime.length - 1].end.hour + buffer.hour,
        minute: busyTime[busyTime.length - 1].end.minute + buffer.minute,
      },
      end: dayEnd,
    })
  } else {
    freeTime = [{ start: dayStart, end: dayEnd }]
  }

  let result = []
  // Available Time Slots are calculated every 30 mins
  freeTime.forEach((el, i) => {
    const startTime = el.start.hour * 60 + el.start.minute
    const endTime = el.end.hour * 60 + el.end.minute
    const shootingLength = parseFloat(packageLength) * 60

    // If Free Time Slot longer than Package Length of Shoot
    if (endTime - startTime >= shootingLength) {
      let startMinute = el.start.minute
      //For every time slot every 15 mins
      if (startMinute === 0) {
        startMinute = 0
      } else if (startMinute <= 15) {
        startMinute = 15
      } else if (startMinute <= 30) {
        startMinute = 30
      } else if (startMinute <= 45) {
        startMinute = 45
      } else if (startMinute <= 60) {
        startMinute = 60
      }

      const newStartTime = el.start.hour * 60 + startMinute
      // result.push({ hour: el.start.hour, minute: j % 60 })

      for (let j = newStartTime; j + shootingLength <= endTime; j += 60) {
        const slot = { hour: (j - (j % 60)) / 60, minute: j % 60 }
        result.push(slot)
      }
    }
  })

  if (!!isToday) {
    const curHour = Number(DateTime.now().setZone(timezone).toFormat('HH'))
    const curMinute = Number(DateTime.now().setZone(timezone).toFormat('mm'))

    result = result.filter((el) => el.hour > curHour || (el.hour === curHour && el.minute > curMinute))
  }

  return result
}

export const disambleOverOneDay = (busy) => {
  let result = []
  busy.forEach((el) => {
    const dayDiff = new Date(el['end']).getDate() - new Date(el['start']).getDate()
    const oneFullDay =
      dayDiff === 1 && new Date(el['end']).getHours() === 0 && new Date(el['start']).getHours() === 0

    if (dayDiff > 0 && !oneFullDay) {
      const endOfFirstDay = moment(el['start']).endOf('date').unix() + 1

      result.push({
        start: el['start'],
        end: moment(endOfFirstDay * 1000).format(),
      })
      for (let i = dayDiff, startDay = endOfFirstDay; i > 1; i--, startDay += 86400) {
        result.push({
          start: moment(startDay * 1000).format(),
          end: moment((startDay + 86400) * 1000).format(),
        })
      }
      result.push({
        start: moment(el['end']).startOf('date').format(),
        end: el['end'],
      })
    } else {
      result.push(el)
    }
  })
  return result
}

function getId(url) {
  // This regex is not accurate, but the former regex in package editor can filter youtube watch and embed urls
  // will change it to only match watch link
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#]*).*/
  const match = url.match(regExp)

  //Only get id from watch url
  if ((match && match[1] === 'watch?') || (match && match[1] === 'youtu.be/')) {
    return match && match[7].length === 11 ? match[7] : null
  } else {
    return null
  }
}

export const covertYtbUrl = (url) => {
  const videoId = getId(url)

  if (!videoId) {
    return url
  } else {
    const embed = 'https://www.youtube.com/embed/' + videoId
    return embed
  }
}

export function convertToYouTubeEmbedURL(videoURL) {
  // Check if the provided URL is a valid YouTube URL
  const youtubePattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/([^?]+)/
  const match = videoURL.match(youtubePattern)

  if (match && videoURL?.includes(`https://www.youtube.com/embed`)) return videoURL

  if (match && match[4]) {
    const videoID = match[4]
    return `https://www.youtube.com/embed/${videoID}`
  } else {
    // If the URL doesn't match the expected format, return null or handle the error accordingly
    return null
  }
}

function getVimeoId(url) {
  // Match only vimeo website url
  // player url will be falsy
  const regExp =
    /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^]*)\/videos\/|)(\d+)(?:|\/\?)/
  const match = url.match(regExp)

  //Only get id from website url
  if (!!match) {
    return match[4]
  } else {
    return null
  }
}

export const convertVimeoUrl = (url) => {
  const videoId = getVimeoId(url)

  if (!videoId) {
    return url
  } else {
    const embed = 'https://player.vimeo.com/video/' + videoId
    return embed
  }
}

export const convertContract = (valueArray, splitText) => {
  let returnedHTML = splitText
    .map((text) => {
      let newText

      if (!!valueArray[0]) {
        for (let i = 2; i < 77; i++) {
          const openInputStr = `<input style='width: ${
            i * 10
          }px; height: 30px; font-size: 16px; padding-left: 4px; margin: 3px 0;' id='contract-input'>`

          if (text.search(openInputStr) > 0) {
            newText = text.replace(openInputStr, valueArray[0])
          }
        }
      } else if (!valueArray[0]) {
        for (let i = 2; i < 77; i++) {
          const openInputStr = `<input style='width: ${
            i * 10
          }px; height: 30px; font-size: 16px; padding-left: 4px; margin: 3px 0;' id='contract-input'>`

          if (text.search(openInputStr) > 0) {
            newText = text.replace(openInputStr, '_'.repeat(i))
          }
        }
      } else {
        newText = text
      }

      valueArray.shift()
      return newText
    })
    .join('')

  return returnedHTML
}

export const replaceWithInput = (body, disabled) => {
  let editedContract = body
    .replace(/_{76,}/g, `${dynamicContractInput(76, disabled)}</input>`)
    .replace(/_{74,}/g, `${dynamicContractInput(74, disabled)}</input>`)
    .replace(/_{72,}/g, `${dynamicContractInput(72, disabled)}</input>`)
    .replace(/_{70,}/g, `${dynamicContractInput(70, disabled)}</input>`)
    .replace(/_{68,}/g, `${dynamicContractInput(68, disabled)}</input>`)
    .replace(/_{66,}/g, `${dynamicContractInput(66, disabled)}</input>`)
    .replace(/_{64,}/g, `${dynamicContractInput(64, disabled)}</input>`)
    .replace(/_{62,}/g, `${dynamicContractInput(62, disabled)}</input>`)
    .replace(/_{60,}/g, `${dynamicContractInput(60, disabled)}</input>`)
    .replace(/_{58,}/g, `${dynamicContractInput(58, disabled)}</input>`)
    .replace(/_{56,}/g, `${dynamicContractInput(56, disabled)}</input>`)
    .replace(/_{54,}/g, `${dynamicContractInput(54, disabled)}</input>`)
    .replace(/_{52,}/g, `${dynamicContractInput(52, disabled)}</input>`)
    .replace(/_{50,}/g, `${dynamicContractInput(50, disabled)}</input>`)
    .replace(/_{48,}/g, `${dynamicContractInput(48, disabled)}</input>`)
    .replace(/_{46,}/g, `${dynamicContractInput(46, disabled)}</input>`)
    .replace(/_{44,}/g, `${dynamicContractInput(44, disabled)}</input>`)
    .replace(/_{42,}/g, `${dynamicContractInput(42, disabled)}</input>`)
    .replace(/_{40,}/g, `${dynamicContractInput(40, disabled)}</input>`)
    .replace(/_{38,}/g, `${dynamicContractInput(38, disabled)}</input>`)
    .replace(/_{36,}/g, `${dynamicContractInput(36, disabled)}</input>`)
    .replace(/_{34,}/g, `${dynamicContractInput(34, disabled)}</input>`)
    .replace(/_{32,}/g, `${dynamicContractInput(32, disabled)}</input>`)
    .replace(/_{30,}/g, `${dynamicContractInput(30, disabled)}</input>`)
    .replace(/_{28,}/g, `${dynamicContractInput(28, disabled)}</input>`)
    .replace(/_{26,}/g, `${dynamicContractInput(26, disabled)}</input>`)
    .replace(/_{24,}/g, `${dynamicContractInput(24, disabled)}</input>`)
    .replace(/_{22,}/g, `${dynamicContractInput(22, disabled)}</input>`)
    .replace(/_{20,}/g, `${dynamicContractInput(20, disabled)}</input>`)
    .replace(/_{18,}/g, `${dynamicContractInput(18, disabled)}</input>`)
    .replace(/_{16,}/g, `${dynamicContractInput(16, disabled)}</input>`)
    .replace(/_{14,}/g, `${dynamicContractInput(14, disabled)}</input>`)
    .replace(/_{12,}/g, `${dynamicContractInput(12, disabled)}</input>`)
    .replace(/_{10,}/g, `${dynamicContractInput(10, disabled)}</input>`)
    .replace(/_{8,}/g, `${dynamicContractInput(8, disabled)}</input>`)
    .replace(/_{6,}/g, `${dynamicContractInput(6, disabled)}</input>`)
    .replace(/_{4,}/g, `${dynamicContractInput(4, disabled)}</input>`)
    .replace(/_{2,}/g, `${dynamicContractInput(2, disabled)}</input>`)

  return editedContract
}

export function splitString(str, delimiter) {
  const index = str.indexOf(delimiter)
  if (index === -1) {
    return [str]
  } else {
    return [str.slice(0, index), str.slice(index + delimiter.length)]
  }
}
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

export const imgUrlToFile = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        }),
    )
    .then((dataUrl) => dataURLtoFile(dataUrl, url.split('/').slice(-1)[0]))

export const objectToQueryString = (object) => {
  return Object.keys(JSON.parse(JSON.stringify(object)))
    .filter((k) => !!k)
    .map((key) => {
      const value = object[key]

      // TO DO: Handle edge cases like value being an array etc.

      return `${key}=${value}`
    })
    .join('&')
}

export const determinePortrait = (numOfPacks, index, pack) => {
  let renderPortrait = false
  let error = false

  // FALSE: landscpae, TRUE: portrait
  if (numOfPacks === 5 && index > 1) {
    renderPortrait = true
  } else if (numOfPacks === 3 || numOfPacks === 6) {
    renderPortrait = true
  }

  if (!!renderPortrait) {
    error = !pack?.portraitImage ? true : false
  } else {
    error = !pack?.landscapeImage ? true : false
  }

  return { error: error, renderPortrait: renderPortrait }
}

export const validateEmail = (email) => {
  let error = []
  if (email) {
    if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
      error.push('- Please provide valid email')
    }
  }
  return error
}
export const recursiveUpdateChild = (node) => {
  if (Array.isArray(node)) {
    return node.map((childNode) => {
      if (typeof childNode === 'object') {
        let updatedNode
        if (childNode.type !== 'br' && childNode.type !== 'p') {
          updatedNode = { ...childNode, type: 'span' }
        } else {
          updatedNode = childNode
        }

        return {
          ...updatedNode,
          props: {
            ...updatedNode.props,
            children: recursiveUpdateChild(updatedNode?.props?.children),
          },
        }
      }
      return childNode
    })
  }

  return node
}

export const replaceTags = (htmlNode) => {
  if (Array.isArray(htmlNode)) {
    return htmlNode.map((childNode) => {
      return {
        ...childNode,
        type: 'p',
        props: {
          ...childNode.props,
          children: recursiveUpdateChild(childNode?.props?.children),
        },
      }
    })
  }
  return htmlNode
}

export const convertToParagraphs = (htmlString) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  // Replace &nbsp; with <br> and extract text content from all nodes
  const textNodes = Array.from(doc.body.childNodes).map((node) => node.textContent.replace(/&nbsp;/g, '<br>'))

  // Wrap each text block in <p> tags
  const paragraphs = textNodes.map((text, index) => (
    <p key={index} dangerouslySetInnerHTML={{ __html: text }} />
  ))

  return paragraphs
}

export const convertToText = (htmlString) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  const textNodes = Array.from(doc.body.childNodes).map((node) => node.textContent.replace(/&nbsp;/g, ' '))
  const joinedText = textNodes.join('<br>')
  const content = <div dangerouslySetInnerHTML={{ __html: joinedText }} />
  return content
}

// export const sortContactForm = (contactForm) => {
//   let sortedForm = []

//   sortedForm.push(contactForm.filter((el) => el.fieldType === 7)[0])

//   sortedForm.push(contactForm.filter((el) => el.fieldType === 8)[0])
//   sortedForm.push(contactForm.filter((el) => el.fieldType === 1)[0])
//   sortedForm.push(contactForm.filter((el) => el.fieldType === 5)[0])
//   sortedForm.push(contactForm.filter((el) => el.fieldType === 4)[0])

//   const sortedTextAreas = contactForm
//     .filter((el) => el.fieldType === 2)
//     .sort((a, b) => a.orderPosition - b.orderPosition)

//   let result = sortedForm.concat(sortedTextAreas)

//   return result.filter((el) => !!el)
// }
export const sortContactForm = (contactForm) => {
  let sortedForm = []

  sortedForm.push(contactForm.filter((el) => el.fieldType === 7)[0])
  sortedForm.push(contactForm.filter((el) => el.fieldType === 8)[0])
  sortedForm.push(contactForm.filter((el) => el.fieldType === 1)[0])
  sortedForm.push(contactForm.filter((el) => el.fieldType === 5)[0])
  sortedForm.push(contactForm.filter((el) => el.fieldType === 4)[0])

  const sortedTextAreas = contactForm
    .filter((el) => el.fieldType === 2)
    .sort((a, b) => a.orderPosition - b.orderPosition)

  const result = sortedForm.concat(sortedTextAreas)

  return result
}

export const checkEmptyAnalyticYear = (yearArr) => {
  let empty = true

  yearArr.forEach((month) => {
    if (!month.revenue) {
      empty = false
    }
  })

  return empty
}

export const validateWorkTimeRange = (workTimes) => {
  let result = ''

  if (workTimes.length === 1) {
    if (Number(workTimes[0].start) >= Number(workTimes[0].end)) {
      result = 'Invalid'
    }
    return result
  }

  workTimes.forEach((el, i) => {
    if (Number(el.start) >= Number(el.end)) {
      result = 'Invalid'
      return
    } else {
      workTimes
        .filter((w, idx) => idx !== i)
        .forEach((time) => {
          if (
            (Number(time.start) < Number(el.end) && Number(time.start) >= Number(el.start)) ||
            (Number(time.end) <= Number(el.end) && Number(time.end) > Number(el.start))
          ) {
            result = 'Overlap'
            return
          }
        })
    }
  })
  return result
}
